<template>
  <div class="fund-reconciliation-page">
    <!-- 顶部标题 -->
    <div class="page-header">
      <h2>资金对账中心</h2>
    </div>

    <!-- 中间统计卡片 -->
    <div class="stat-cards">
      <!-- 资金汇总卡片 -->
      <div class="card fund-summary">
        <p class="card-title">资金汇总</p>
        <div class="summary-items">
          <div class="item">
            <span class="label">账户资金总额</span>
            <span class="value">¥{{ shopAccount.totalAmount | currency }}</span>
          </div>
          <div class="item">
            <span class="label">可提现金额
              <el-button
                style="margin-left: 20px;"
                type="success"
                size="small"
                :disabled="shopAccount.withdrawAmount <= 0"
                @click="withdrawDialogVisible = true"
              >提现</el-button></span>
            <div class="value-btn-group" style="display: flex; align-items: center; gap: 12px;">
              <span class="value text-green">¥{{ shopAccount.withdrawAmount | currency }}</span>

            </div>
          </div>

          <!-- 提现金额输入弹框 -->
          <el-dialog
            title="提现申请"
            :visible.sync="withdrawDialogVisible"
            width="350px"
            left
          >
            <el-form>
              <!-- 新增提现注意事项提示 -->
              <el-alert
                title="提现到账时间为工作日24小时内，如遇法定节假日，最晚到账时间自动顺延至下个工作日。单笔提现金额不低于1000元，余额不足一千元时将每月统一结算"
                type="info"
                :closable="false"
                style="
                  margin-bottom: 15px;
                  background: #ecf5ff;
                  border-color: #d9ecff;
                  color: #409eff;  /* 蓝色文字，Element UI主色 */
                "
              ></el-alert>

              <el-form-item
                label="提现金额"
                label-position="top"
                style="margin-bottom: 8px;"
              >
                <el-input
                  v-model.number="withdrawAmountInput"
                  type="number"
                  placeholder="请输入提现金额"
                  :min="0"
                  :max="shopAccount.withdrawAmount"
                  style="width: 280px;"
                >
                  <template slot="prefix">¥</template>
                  <template slot="append">
                    <span style="color: #909399; padding: 0 8px;">
                      最高可提{{ shopAccount.withdrawAmount | currency }}
                    </span>
                  </template>
                </el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="withdrawDialogVisible = false">取消</el-button>
              <el-button type="success" @click="submitWithdraw">确认提现</el-button>
            </div>
          </el-dialog>
          <div class="item">
            <span class="label">提现中金额</span>
            <span class="value text-orange">¥{{ shopAccount.withdrawingAmount | currency }}</span>
          </div>
        </div>
      </div>

      <!-- 商家公户信息卡片 -->
      <div class="card business-account">
        <!-- 标题行添加flex布局，包含标题和编辑按钮 -->
        <div class="card-header" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
          <p class="card-title">商家公户信息</p>
          <el-button
            v-if="identityObj.identityTypeCode != 4"
            type="text"
            size="small"
            icon="el-icon-edit"
            @click="showEditAccountDialog"
          >编辑</el-button>
        </div>
        <div class="account-info">
          <p><span class="label">开户名称：</span>{{ shopAccount.bankCompanyName }}</p>
          <p><span class="label">开户银行：</span>{{ shopAccount.bankName }}</p>
          <!-- 公户账号行添加复制图标 -->
          <p style="display: flex; align-items: center; gap: 8px;">
            <span class="label">公户账号：</span>
            <span>{{ shopAccount.bankCardNum }}</span>
            <el-tooltip effect="light" content="复制" placement="right">
              <el-button
                type="text"
                size="small"
                icon="el-icon-copy-document"
                @click="copyBankCardNum"
                style="padding: 0; color: #606266;"
              ></el-button>
            </el-tooltip>
          </p>
        </div>
      </div>

      <!-- 公户信息编辑弹框 -->
      <el-dialog
        title="编辑公户信息"
        :visible.sync="editAccountDialogVisible"
        width="500px"
        center
      >
        <el-form :model="editingAccount" label-width="120px">
          <el-form-item label="开户名称" required>
            <el-input v-model="editingAccount.bankCompanyName"></el-input>
          </el-form-item>
          <el-form-item label="开户银行" required>
            <el-input v-model="editingAccount.bankName"></el-input>
          </el-form-item>
          <el-form-item label="公户账号" required>
            <el-input v-model="editingAccount.bankCardNum"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="editAccountDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitEditAccount">保存</el-button>
        </div>
      </el-dialog>

    </div>

    <!-- 提现记录 & 收支明细切换 -->
    <div class="record-container">
      <el-tabs v-model="activeTab" @tab-click="handleTabChange">
        <el-tab-pane label="提现记录" name="withdraw"></el-tab-pane>
        <el-tab-pane label="收支明细" name="incomeExpense"></el-tab-pane>
      </el-tabs>

      <!-- 列表内容 -->
      <div class="record-list">
        <!-- 提现记录 -->
        <div v-show="activeTab === 'withdraw'">
          <div class="search-container" style="margin-bottom: 15px;">
            <el-input
              v-model="keyword"
              placeholder="搜索交易号..."
              style="width: 300px;"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </div>

          <el-table :data="withdrawRecords" border>
            <el-table-column
              prop="createTime"
              label="交易时间"
              width="200"
              align="center"
              header-align="center"
            ></el-table-column>
            <el-table-column
              prop="type"
              label="交易类型"
              width="150"
              align="center"
              header-align="center"
            ></el-table-column>
            <el-table-column
              prop="amount"
              label="交易金额"
              width="120"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope"><span style="color: red;">-¥{{ scope.row.amount | currency }}</span></template>
            </el-table-column>
            <el-table-column
              prop="statusName"
              label="交易状态"
              width="120"
              align="center"
              header-align="center"
            ></el-table-column>
            <el-table-column
              prop="applyNo"
              label="交易单号"
              align="center"
              header-align="center"
            ></el-table-column>
          </el-table>
          <el-pagination
            :current-page="pageNum"
            :page-size="pageSize"
            :total="withdrawTotal"
            @current-change="handlePageChange"
            background
          ></el-pagination>
        </div>

        <!-- 收支明细 -->
        <div v-show="activeTab === 'incomeExpense'">
          <div class="search-container" style="margin-bottom: 15px;">
            <el-input
              v-model="keyword"
              placeholder="搜索交易号..."
              style="width: 300px;"
              @keyup.enter.native="handleSearch"
            ></el-input>
          </div>
          <el-table :data="incomeExpenseList" border >
            <!-- 添加align（数据对齐）和header-align（标题对齐）属性 -->
            <el-table-column
              prop="dealNo"
              label="交易单号"
              width="400"
              align="center"
              header-align="center"
            ></el-table-column>
            <el-table-column
              prop="dealType"
              label="交易类型"
              width="150"
              align="center"
              header-align="center"
            ></el-table-column>
            <el-table-column
              prop="amount"
              label="订单金额（含运费）"
              width="100"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope"><span style="color: green;">+¥{{ scope.row.amount }}</span></template>
            </el-table-column>
            <el-table-column
              prop="wechatPlatformFee"
              label="微信支付手续费（0.2%）"
              width="120"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope"><span style="color: red;">-¥{{ scope.row.wechatPlatformFee }}</span></template>
            </el-table-column>
            <el-table-column
              prop="platformServiceFee"
              width="120"
              align="center"
              header-align="center"
            >
            <template slot="header">
              <span>平台服务费
                <el-tooltip
                  effect="dark"
                  content="农事服务0% 农资服务3%"
                  placement="top">
                  <i class="el-icon-question" style="color:#409EFF;cursor:pointer;margin-left:5px"></i>
                </el-tooltip>
              </span>
            </template>

              <template slot-scope="scope"><span style="color: red;">-¥{{ scope.row.platformServiceFee }}
                （<span v-if="scope.row.dealType == '农事服务'">0%</span><span v-else>3%</span>）</span></template>
            </el-table-column>
            <el-table-column
              prop="withdrawAmount"
              label="可提现金额"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope"><span style="color: green;">+¥{{ scope.row.withdrawAmount }}</span></template>
            </el-table-column>
          </el-table>
          <el-pagination
            :current-page="pageNum"
            :page-size="pageSize"
            :total="total"
            @current-change="handlePageChange"
            background
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 假设货币格式化工具函数已存在
import { formatCurrency } from '@/utils/format';
import { getShopAccount,
  getWithdrawList,
  getBalanceLogList,
  withdrawApply
 } from '@/api/fund';
 import {editShop} from '@/api/shfw';
 import { mapGetters } from "vuex";

export default {
  data() {
    return {
      activeTab: 'withdraw',
      pageNum: 1,
      pageSize: 10,
      withdrawTotal: 0,
      total: 100,
      withdrawRecords: [],
      incomeExpenseList: [],
      shopAccount: {},
      keyword: '',
      withdrawDialogVisible: false,
      withdrawAmountInput: 0, //输入的提现金额
      editAccountDialogVisible: false,  // 新增：编辑弹框显示控制
      editingAccount: {},
      shopAccountId: null
    };
  },
  filters: {
    currency(value) {
      return formatCurrency(value);
    }
  },
  computed: {
    ...mapGetters(["identityObj"])
  },
  methods: {

    // 新增：复制公户账号方法
    async copyBankCardNum() {
      try {
        await navigator.clipboard.writeText(this.shopAccount.bankCardNum);
        this.$message.success('公户账号复制成功');
      } catch (error) {
        this.$message.error('复制失败，请手动复制');
      }
    },

    showEditAccountDialog() {
      // 复制当前公户信息到临时对象（避免直接修改原数据）
      this.editingAccount = { ...this.shopAccount };
      this.editAccountDialogVisible = true;
    },

    // 提交编辑
    async submitEditAccount() {
      // 简单校验（根据实际需求可扩展）
      if (!this.editingAccount.bankCompanyName || !this.editingAccount.bankName || !this.editingAccount.bankCardNum) {
        this.$message.error('请填写所有必填字段');
        return;
      }

      // 调用更新接口
      this.editingAccount.id = this.editingAccount.shopId;
      const res = await editShop(this.editingAccount);
      if (res.code === 0) {
        this.$message.success('公户信息更新成功');
        this.shopAccount = { ...this.editingAccount };  // 更新原数据
        this.editAccountDialogVisible = false;  // 关闭弹框
      } else {
        this.$message.error(res.msg);
      }
    },

    // 获取商家公户信息
    async getShopAccount() {
      try {
        const res = await getShopAccount();
        this.shopAccount = res.data;
        this.shopAccountId = res.data.shopAccountId;
      } catch (error) {
        console.error('获取商家公户信息失败:', error);
      }
    },

    // 搜索处理
    handleSearch() {
      console.log('搜索关键词：', this.keyword);
      this.pageNum = 1; // 搜索时重置页码
      this.fetchListData(this.activeTab);
    },

    handleTabChange(tab) {
      this.activeTab = tab.name;
      this.pageNum = 1; // 切换tab时重置页码
      this.fetchListData(tab.name);
    },
    handlePageChange(currentPage) {
      this.pageNum = currentPage;
      this.fetchListData(this.activeTab);
    },
    async fetchListData(type) {
      if (type === 'withdraw') {
        //获取提现记录数据
        let res = await getWithdrawList({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          keyword: this.keyword
        });
        console.log(res, "提现数据");
        if (res.code === 0) {
          this.withdrawTotal = Number(res.data.total);
          this.withdrawRecords = res.data.records;
        }
      } else {
        //获取收支明细数据
        let res = await getBalanceLogList({
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          type: 1,
          keyword: this.keyword
        });
        console.log(res, "收支明细数据");
        if (res.code === 0) {
          this.total = Number(res.data.total);
          this.incomeExpenseList = res.data.records;
        }

      }
    },
    // 提交提现申请
    async submitWithdraw() {
      // 基础校验
      if (this.withdrawAmountInput < 1000) {
        this.$message.info('单笔提现金额不能低于1000元');
        return;
      }
      if (this.withdrawAmountInput > this.shopAccount.withdrawAmount) {
        this.$message.info(`提现金额不能超过可提现上限${this.shopAccount.withdrawAmount}`);
        return;
      }

      //提现提交
      let res = await withdrawApply({
        amount: this.withdrawAmountInput
      });
      if (res.code === 0) {
        this.$message.success('提现申请提交成功');
        this.withdrawDialogVisible = false;  // 关闭弹框
        this.getShopAccount();  // 刷新账户信息
        this.fetchListData('withdraw');  // 刷新提现记录
      } else {
        this.$message.error(res.message);
      }
    }
  },
  mounted() {
    this.getShopAccount();
    // 初始化加载数据
    this.fetchListData('withdraw');
  }
};
</script>

<style scoped>
.fund-reconciliation-page {
  padding: 20px;
  min-height: 100vh;
  background: #f5f7fa;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  font-size: 24px;
  color: #303133;
  font-weight: 500;
}

.stat-cards {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.card {
  flex: 1;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
}

.card-title {
  font-size: 18px;
  color: #606266;
  margin-bottom: 15px;
}

.summary-items {
  display: flex;
  gap: 20px;
}

.summary-items .item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.summary-items .label {
  font-size: 16px;
  color: #909399;
}

.summary-items .value {
  font-size: 18px;
  font-weight: 500;
  color: #303133;
}

.text-green {
  color: #67c23a !important;
}

.text-orange {
  color: #e6a23c !important;
}

/* 调整商家公户信息卡片宽度 */
.business-account {
  flex: 0.5;  /* 原.card的flex:1会让卡片等比分配空间，0.6表示占据父容器60%的比例（相对于其他flex:1的卡片） */
  min-width: 300px;  /* 设置最小宽度防止过窄 */
}

.business-account .account-info p {
  margin: 8px 0;
  font-size: 14px;
  color: #606266;
}

.business-account .label {
  color: #909399;
  margin-right: 8px;
}

.record-container {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,0.1);
}

.record-list {
  margin-top: 20px;
}
</style>
